import { useMemo, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { sendMagicLink } from '../lib/auth';

export default function Login() {
  const [searchParams] = useSearchParams();
  const callbackError = useMemo(() => searchParams.get('error'), [searchParams]);
  const [email, setEmail] = useState('');
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [err, setErr] = useState<string | null>(callbackError);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    if (!email) return;
    setSending(true);
    setErr(null);

    const redirectTo = `${window.location.origin}/auth/callback`;
    const { error } = await sendMagicLink(email.trim().toLowerCase(), redirectTo);

    setSending(false);
    if (error) {
      setErr(error.message);
      return;
    }
    setSent(true);
  }

  return (
    <div
      className="min-vh-100 d-flex align-items-center justify-content-center bg-light"
      style={{ background: 'var(--bb-bg)' }}
    >
      <div className="card shadow-sm" style={{ maxWidth: 420, width: '100%' }}>
        <div className="card-body p-4">
          <div className="text-center mb-4">
            <i
              className="bi bi-clipboard2-pulse-fill"
              style={{ fontSize: '2.5rem', color: 'var(--bb-primary)' }}
            />
            <h1 className="h4 mt-2 mb-1">BebêCare · Admin</h1>
            <p className="text-muted small mb-0">Acesso restrito</p>
          </div>

          {sent ? (
            <div className="alert alert-success">
              <i className="bi bi-envelope-check me-2" />
              Verifica seu email <strong>{email}</strong>. Mandamos um link
              mágico — clique pra entrar (válido por 1 hora).
              <hr />
              <button
                type="button"
                className="btn btn-sm btn-link p-0"
                onClick={() => {
                  setSent(false);
                  setEmail('');
                }}
              >
                Usar outro email
              </button>
            </div>
          ) : (
            <form onSubmit={onSubmit} noValidate>
              <label htmlFor="email" className="form-label small fw-semibold">
                Email
              </label>
              <input
                id="email"
                type="email"
                className="form-control mb-3"
                placeholder="voce@dominio.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoComplete="email"
                autoFocus
              />

              {err && (
                <div className="alert alert-danger small py-2">{err}</div>
              )}

              <button
                type="submit"
                className="btn btn-bb w-100"
                disabled={sending}
              >
                {sending ? 'Enviando…' : 'Enviar link mágico'}
              </button>
            </form>
          )}

          <p className="small text-muted mt-3 mb-0 text-center">
            Esqueceu como funciona?{' '}
            <button
              type="button"
              className="btn btn-link p-0 small align-baseline"
              onClick={() => {
                setSent(false);
                setEmail('');
                setErr(null);
              }}
            >
              Cadastro só via convite
            </button>
          </p>
        </div>
      </div>
    </div>
  );
}
